export const shortCodePattern = /^[a-z][a-z0-9]{4}$/i;
export const numericIDPattern = /^\d+$/;

interface BuildDesignAssetPathOptions {
  groupID: string;
  assetID: string;
  groupShortCode?: string | null;
  assetShortCode?: string | null;
  search?: string;
}

const appendSearch = (path: string, search?: string) => {
  if (!search) {
    return path;
  }

  return path + (search.startsWith('?') ? search : `?${search}`);
};

export const buildDesignAssetPath = ({
  groupID,
  assetID,
  groupShortCode,
  assetShortCode,
  search,
}: BuildDesignAssetPathOptions) => {
  const hasCanonicalShortCodes =
    !!groupShortCode &&
    !!assetShortCode &&
    shortCodePattern.test(groupShortCode) &&
    shortCodePattern.test(assetShortCode);

  if (hasCanonicalShortCodes) {
    return appendSearch(
      `/design-guidelines/${groupShortCode.toLowerCase()}/${assetShortCode.toLowerCase()}`,
      search
    );
  }

  // 短码不完整时必须整体回退，非法数字 ID 直接暴露调用错误，避免生成混合或损坏地址。
  if (!numericIDPattern.test(groupID) || !numericIDPattern.test(assetID)) {
    throw new TypeError('Design asset fallback IDs must both be numeric');
  }

  return appendSearch(`/design-guidelines/${groupID}/${assetID}`, search);
};
